<i18n lang='yml' src='../i18n/LogbookForm.yml'></i18n>
<template>
  <div class="layout-tile">
    <div class="content-block">
      <div class="post-view">
        <div class="post-content">
          <flash :message_type="message_type" :message_text="message_text"/>
          <Form ref="observer" v-slot="{ errors }" @submit="submitUserInput" @invalid-submit="setErrorMessage">
              <input ref="csrfTokenField" type="hidden" v-model="csrfToken" name="authenticity_token">
              <div class="row">
                <div class="col-sm-4">
                  <div class="form-group">
                    <label for="training_program">{{$t('training_program')}}</label>
                    <Field
                      :name="$t('training_program')" 
                      rules="required"
                      v-slot="{ errors, field }"
                      v-model="logbookData.trainingProgram">
                      <multi-select
                        :options="getOptions(dropDownPrograms)"
                        searchable=true
                        class="single-select"
                        @search-change="onTextEntry"
                        label="label"
                        :clear-on-select="true"
                        :value="logbookData.trainingProgram"
                        @select="setTrainingStandards"
                        :hide-selected="true"
                        :internal-search="false"
                        :loading="loading"
                        key="value"
                        :class="{'is-invalid': errors[0]}" 
                        v-bind="field"
                      />
                      <div class="invalid-feedback" :id="`${$t('training_standard')}_error`" v-if="errors[0]">
                        <font-awesome-icon :icon="['far', 'exclamation-circle']" fixed-width />
                        <span>{{ errors[0] }}</span> 
                      </div>
                    </Field>
                  </div>
                  <div class="form-group" v-if="logbookData.trainingProgram != null">
                    <label for='training_standard'>{{ $t('training_standard') }}</label>
                    <Field
                      :name="$t('training_standard')" 
                      rules="required"
                      v-slot="{ errors, field}"
                      v-model="logbookData.trainingStandard">
                      <multi-select
                        :options="getOptions(dropDownStandards)"
                        searchable=true
                        class="single-select"
                        @search-change="onTextEntry"
                        :label="label"
                        :clear-on-select="true"
                        :value="logbookData.trainingStandard"
                        :hide-selected="true"
                        :internal-search="false"
                        :loading="loading"
                        key="value"
                        :class="{'is-invalid': errors[0]}" 
                        v-bind="field"
                      />
                      <div class="invalid-feedback" :id="`${$t('training_standard')}_error`" v-if="errors[0]">
                        <font-awesome-icon :icon="['far', 'exclamation-circle']" fixed-width />
                        <span>{{ errors[0] }}</span> 
                      </div>
                    </Field>
                  </div>
                  <button type="submit" class="btn btn-primary btn-success no-shadow">{{ $t('create') }}</button>
                </div>
              </div>
              <div v-if="Object.keys(errors).length > 0 && showErrorBanner" class="alert alert-danger" role="alert">
                <span class="red mr-2"> <font-awesome-icon :icon="['far', 'exclamation-circle']"/></span>
                {{ $t('error_warning') }}
              </div>
          </Form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import flash from '../../shared/flash_messages/components/Flash.vue';
  import '../../../javascripts/application/vee-validate-rules.js'
  import { sendAjaxRequest, ajaxResponseMessage } from '../../shared/typescripts/ajax.ts'
  import { getListArray, hasErrors, setErrorMessage, checkForError } from '../../shared/typescripts/error.ts'
  import { Form, Field } from 'vee-validate'

  export default {
    components: { 
      flash, 
      Form, 
      Field 
    },

    props: ['locale', 'training_programs_path', 'submit_logbook_path'],
    
    data() {
      return { 
        logbookData: {
          trainingProgram: null,
            trainingStandard  : null
        },
        dropDownStandards: [],
        dropDownPrograms: [],
        csrfToken: $("meta[name='csrf-token']").attr("content"),
        searchLength: 1,
        limit: 10,
        loading: false,
        message_text: [],
        message_type: "",
        showErrorBanner: false
      }
    },


    mounted () {
      this.getTrainingProgramData()
    },

    methods: {
      getOptions(data) {  
        let newArray = [];
        data.map((item) => {
          let _vm = this
          newArray.push({value: item.id, label: item.label, standards: item.standards})
        })
        return newArray
      },
      // Searches through all of the system's training programs and if it finds any it adds them to the dropdown for the user to select

      onTextEntry(search) {
        if(search.length >= this.searchLength){
          this.loading=true    
          this.getTrainingProgramData(search).then((response) => {
            this.loading=false        
          })
        }
      },

      async getTrainingProgramData(search = "") {  
        const _vm = this;
        // Three characters is long enough to limit search time so we aren't searching for single or double characters
        // which could produce thousands of results and take an exceptionally long time to run
        _vm.dropDownPrograms = [];

        let payload = { search: search, limit: _vm.limit }

        sendAjaxRequest('GET', _vm.training_programs_path, 'json', payload, this.getTrainingProgramDataSuccess, this.throwError)
        
        this.dropDownPrograms = []
      },

      getTrainingProgramDataSuccess(data) {
        const _vm = this;
        data.forEach((program) => {
          _vm.dropDownPrograms.push({
            id: program.id,
            label: program.name.en,
            standards: program.training_standards
          })
        })
      },

      throwError() {
        console.log("Error");
        this.loading = false;
      },

      setTrainingStandards({ commit }, value) {
        this.dropDownStandards = []
        this.logbookData.trainingStandard = null
        value.standards.forEach((standard) => {
          if(standard.active)  {
            this.dropDownStandards.push({id: standard.id, label: standard.version})
          }
        })
      },
  
      submitUserInput(event){
        let payload = {logbook: {training_standard_id: this.logbookData.trainingStandard, 
        training_program_id: this.logbookData.trainingProgram}}
        this.message_text = [];
        sendAjaxRequest('POST', this.submit_logbook_path, 'json', payload,  this.ajaxSuccess)
      },

      ajaxSuccess(response) {
        if(response.error){
          console.log("erorrrrrrrrrrrrrrrrrrrrrrrrrr")
          this.message_type = "error";
          this.message_text = response.error  
        }
        else {
          window.location.replace(response.path);
        }
      },

      setErrorMessage({ valuese, errors, results }) {
        setErrorMessage(this, errors)
      }
    }
  }
</script>
